import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useAuth } from '~/contexts/auth';
import { dashboardRoute, homeRoute } from '~/paths';

function HomeRedirector() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(dashboardRoute());
    } else {
      navigate(homeRoute());
    }
  }, [isAuthenticated, navigate]);

  return null;
}

export default HomeRedirector;
